import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";
import {
  BASE_URL,
  LIST_TAXES_REPORT,
  NEW_TAXES_REPORT,
} from "../../../Constants/Config";

const initialState = {
  loading: false,
  taxesreportData: [],
  NewtaxesreportData: [],
  successMessage: "",
  error: "",
};

// Generate pening , fulfilled and rejected action type
export const fetchtaxesreportData = createAsyncThunk(
  "taxesreport/fetchtaxesreportData.",
  async (data, { rejectWithValue }) => {
    try {
      const { token, ...dataNew } = data;

      const response = await axios.post(BASE_URL + LIST_TAXES_REPORT, dataNew, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.status === "Success") {
        return response.data;
      } else if (
        response.data.status === "Failed" &&
        response.data.msg === "No. Data found."
      ) {
        return response.data;
      }
    } catch (error) {
      // throw new Error(error.response.data.message);
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

let abortNewTaxReport = null;

export const fetchNewtaxesreportData = createAsyncThunk(
  "taxesreport/fetchNewtaxesreportData.",
  async (data, { rejectWithValue }) => {
    try {
      if (abortNewTaxReport) {
        abortNewTaxReport.abort();
      }

      abortNewTaxReport = new AbortController();
      const signal = abortNewTaxReport.signal;

      const { token, ...dataNew } = data;

      const response = await axios.post(BASE_URL + NEW_TAXES_REPORT, dataNew, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        signal,
      });
      if (response.data.status === true) {
        return response.data.result;
      } else if (
        response.data.status === false &&
        response.data.message === "No Data found."
      ) {
        return response.data;
      }
    } catch (error) {
      // throw new Error(error.response.data.message);
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);
// Generate pening , fulfilled and rejected action type

const taxesreportSlice = createSlice({
  name: "taxesreport",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchtaxesreportData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchtaxesreportData.fulfilled, (state, action) => {
      state.loading = false;
      state.taxesreportData = action.payload;
      state.error = "";
    });
    builder.addCase(fetchtaxesreportData.rejected, (state, action) => {
      state.loading = false;
      state.taxesreportData = {};
      state.error = action.error.message;
    });

    //for new Taxes Report
    builder.addCase(fetchNewtaxesreportData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchNewtaxesreportData.fulfilled, (state, action) => {
      state.loading = false;
      state.NewtaxesreportData = action.payload;
      state.error = "";
    });
    builder.addCase(fetchNewtaxesreportData.rejected, (state, action) => {
      state.loading = false;
      state.NewtaxesreportData = {};
      state.error = action.error.message;
    });
  },
});

export default taxesreportSlice.reducer;
